import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// import { Flex, Box } from 'rebass';
// import { GlowHeading } from 'components';

const StatusWrapper = styled.div`
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  & > h1 {
    font-size: 50px;
    margin-bottom: 80px;
  }
  # > h2 {
    font-size: 40px;
    margin: 0px;
  }
  & > span {
    width:50px;
    height: 2px;
    background: #4a4a4a;
    margin: 40px 0 20px 0;
  }
  & > a {
    font-size: 30px;
    margin: 0px;
    margin-bottom: 20px;
  }
`;

const ReservationFailedToLoad = ({
  reservationFailedToLoad,
  marketHelpDeskEmail,
  marketHelpDeskLink,
  marketHelpDeskLinkText,
}) => {
  const hasMarketHelpDeskLinkText = !!marketHelpDeskLinkText && marketHelpDeskLinkText !== 'marketHelpDeskLinkText';
  const hasMarketHelpDeskEmail = !!marketHelpDeskEmail && marketHelpDeskEmail !== 'marketHelpDeskEmail';

  return (
    <StatusWrapper align="center">
      <h1>{reservationFailedToLoad}</h1>
      {hasMarketHelpDeskEmail ?
        <a href={`mailto:${marketHelpDeskEmail}`} data-rel="external">{marketHelpDeskEmail}</a>
        : ''}

      {marketHelpDeskLink ?
        <a
          href={marketHelpDeskLink}
          rel="noopener noreferrer"
          target="_blank"
        >{hasMarketHelpDeskLinkText ? marketHelpDeskLinkText : marketHelpDeskLink}</a>
        : ''}
    </StatusWrapper>
  );
};

ReservationFailedToLoad.propTypes = {
  reservationFailedToLoad: PropTypes.string,
  marketHelpDeskEmail: PropTypes.string,
  marketHelpDeskLink: PropTypes.string,
  marketHelpDeskLinkText: PropTypes.string,
};

export default ReservationFailedToLoad;



// WEBPACK FOOTER //
// ./src/loaders/ReservationFailedToLoad/index.js